export default __webpack_public_path__ + "static/media/7.5c7e6d09.png";